export const mapServerStatusToUIStatus = (status) => {
  switch (status) {
    case 'cancelled':
      return 'Cancelled';
    case 'rescheduled':
      return 'Rescheduled';
    case 'received':
    case 'confirmed':
    default:
      return 'Scheduled';
  }
};

export const mapUIStatusToServerStatus = (status) => {
  switch (status) {
    case 'Completed':
    case 'Scheduled':
      return 'confirmed';
    case 'Cancelled':
      return 'cancelled';
    case 'Rescheduled':
      return 'rescheduled';
    default:
      return 'confirmed';
  }
};

export const normalizeAppointmentForUI = (appointment = {}) => {
  const normalizedStatus = mapServerStatusToUIStatus(appointment.status);

  return {
    id: appointment._id || appointment.id,
    _id: appointment._id || appointment.id,
    title: appointment.title || appointment.appointmentTypeLabel || 'Appointment',
    customerName: appointment.customerName || appointment.fullName || 'Unknown customer',
    customerPhone: appointment.customerPhone || appointment.mobileNumber || '',
    customerEmail: appointment.email || appointment.customerEmail || '',
    date: appointment.appointmentDate || appointment.date || '',
    time: appointment.appointmentTime || appointment.preferredTimeLabel || appointment.time || '',
    duration: appointment.duration || 60,
    status: normalizedStatus,
    type: appointment.appointmentTypeLabel || appointment.type || 'Consultation',
    location: appointment.location || '',
    assignedTo: appointment.assignedTo || '',
    notes: appointment.notes || appointment.additionalNotes || '',
    reminderSent: Boolean(appointment.reminderSent),
    createdAt: appointment.createdAt || new Date().toISOString(),
    completedAt: appointment.completedAt || null,
    cancelledAt: appointment.cancelledAt || null,
    cancellationReason: appointment.cancellationReason || '',
  };
};

export const buildAppointmentPayload = (formData = {}) => {
  return {
    title: formData.title || '',
    customerName: formData.customerName || '',
    customerPhone: formData.customerPhone || '',
    email: formData.customerEmail || '',
    fullName: formData.customerName || '',
    mobileNumber: formData.customerPhone || '',
    appointmentDate: formData.date || '',
    appointmentTime: formData.time || '',
    preferredTimeSlot: formData.time || '',
    preferredTimeLabel: formData.time || '',
    appointmentType: formData.type || 'Consultation',
    appointmentTypeLabel: formData.type || 'Consultation',
    duration: formData.duration || 60,
    location: formData.location || '',
    assignedTo: formData.assignedTo || '',
    additionalNotes: formData.notes || '',
    notes: formData.notes || '',
    status: mapUIStatusToServerStatus(formData.status || 'Scheduled'),
  };
};
